import { createSlice } from '@reduxjs/toolkit'

import type { PayloadAction } from '@reduxjs/toolkit'

const initialState: any = {}

const dataSlice = createSlice({
  name: 'data',
  initialState: initialState,
  reducers: {
    putData(state, action: PayloadAction<object>) {
      return { ...state, ...action.payload }
    },
    clearAllData() {
      return {}
    }
  }
})
export const { putData, clearAllData } = dataSlice.actions
export default dataSlice
